import { useMemo } from "react";

export function getDayThreshold() {
  const day = new Date().getDay();
  return day === 0 || day === 6 ? 50 : 20;
}

export function hasCmHighIncrease(row, threshold) {
  const fields = ["dailyBudget", "targetRoas"];
  return fields.some((field) => {
    const f = row?.[field];
    if (f?.valueOriginal === undefined || f?.valueEdited === undefined) return false;
    const original = Number(f.valueOriginal);
    if (original === 0) return false;
    const pct = Math.abs(((Number(f.valueEdited) - original) / original) * 100);
    return pct > threshold;
  });
}

export function useCmPublishRows(cmEditedRows) {
  const threshold = getDayThreshold();

  const allModifiedRowKeys = useMemo(() => {
    return Object.keys(cmEditedRows).filter((rowId) => {
      const row = cmEditedRows[rowId];

      const budgetField = row?.dailyBudget;
      const roasField = row?.targetRoas;

      const budgetChanged =
        budgetField?.valueOriginal !== undefined &&
        budgetField?.valueEdited !== undefined &&
        Number(budgetField.valueEdited) !== Number(budgetField.valueOriginal);

      const roasChanged =
        roasField?.valueOriginal !== undefined &&
        roasField?.valueEdited !== undefined &&
        Number(roasField.valueEdited) !== Number(roasField.valueOriginal);

      return budgetChanged || roasChanged;
    });
  }, [cmEditedRows]);

  const numberOfCampaignsWithHighIncrease = useMemo(
    () =>
      allModifiedRowKeys.filter((key) =>
        hasCmHighIncrease(cmEditedRows[key], threshold),
      ).length,
    [allModifiedRowKeys, cmEditedRows, threshold],
  );

  return { allModifiedRowKeys, numberOfCampaignsWithHighIncrease, threshold };
}
